/**
 * Constants for job management and job editors
 */

// Job ID used for new job creation flow
export const NEW_JOB_ID = '';

// Other job-related constants can be added here
export const JOB_EDITOR_MODES = {
  NEW: 'new',
  EDIT: 'edit',
} as const;

export type JobEditorMode = (typeof JOB_EDITOR_MODES)[keyof typeof JOB_EDITOR_MODES];
